import { Component, Input } from '@angular/core';
import { AuthService } from '../../../Shared/Services/auth.service';
import { UserInfoService } from '../../../Services/user-info.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { DtoAgentVM } from '../../../Model/agents/DtoAgentVM';
import { Router, RouterModule } from '@angular/router';
import { ChangePassWordComponent } from '../change-password/change-password.component';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../../Shared/module/material.module';
import { LoginVm } from '../../../Model/LoginVM';
import { UserType } from '../../../Shared/Enums/UserType';
import { ClientService } from '../../../Services/client.service';
import { DtoClientVM } from '../../../Model/clients/DtoClientVM';
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'app-my-profile',
  standalone: true,
  imports: [RouterModule, CommonModule, TranslateModule, MaterialModule],
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.scss'
})
export class MyProfileComponent {
  currentInfo!: any;
  @Input() IsdDashboard?: boolean = false;
  ShowButns: boolean = true;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  currentUser: LoginVm = {};
  ImgPath = environment.ImgUrl;

  constructor(private api: UserInfoService, private auth: AuthService, private spinner: NgxSpinnerService,
    private toastrService: CustomToastrService, private router: Router, private dialogService: DialogService
    , private ClientApi: ClientService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.spinner.show();
      this.GetCurrentUser();
      if (this.currentUser.userType == UserType.Client) {
        this.GetClientData(this.currentUser.loggedId);
      }
      else {
        this.GetMyData();
      }
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
  }

  GetClientData(clientId: any) {
    if (this.auth.isAuthenticated([UserType.Client])) {
      this.ClientApi.GetClientData(clientId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            this.spinner.hide();
            if (data.isCompleted) {
              this.currentInfo = this.MapClientInfo(data.result.payload);
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  MapClientInfo(data: DtoClientVM) {
    let currentInfo = {
      id: data.id,
      name: data.name,
      logo: this.ImgPath + "/" + data.clientLogoURL,
      phone: data.clientPhone,
      email: data.email,
      address: data.clientAddress
    };

    return currentInfo;
  }

  MapCurrentInfo(data: DtoAgentVM) {
    let currentInfo = {
      id: data.id,
      name: data.nameAgent,
      logo: this.ImgPath + "/" + data.agentLogo,
      phone: data.agentPhone,
      email: data.email,
      address: data.agentGovernorate + ' - ' + data.agentAddress
    };

    return currentInfo;
  }

  GetMyData() {
    if (this.auth.isAuthenticated()) {
      this.api.GetAgentInfo()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.currentInfo = this.MapCurrentInfo(res.payload);
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ChangePassWord() {
    this.dialogService.openDialog(ChangePassWordComponent);
  }
}
